import { gql } from '@apollo/client'

export const MODIFY_TENANT_MUTATION = gql`
  mutation ModifyTenant($input: TenantInput!, $tenantCode: Int!) {
    modifyTenant(input: $input, tenantCode: $tenantCode) {
      message
    }
  }
`
